define('page/sales', [
    'common/util', 'jquery', 'log', 'page/index/sale-car', 'data/wechat-entry',
], (Util, $, log, saleCar, wechat) => {
    $(() => {
        wechat.replaceAppointment('2654');
    });
    // 历史售出轮播图
    function initSellerStory() {
        const $aLi = $('.history-sales-cars li');
        const $oUl = $('.history-sales-cars ul');
        const $aLiWidth = $aLi.eq(0).width();
        let index = 0;
        const oLeft = $('.leftLogo');
        const oRight = $('.rightLogo');
        function switchLi(index2) {
            $oUl.find('img').each((i, dom) => {
                const ndImage = $(dom);
                if (ndImage.is(':visible')) {
                    const ndImageUrl = ndImage.attr('data-src');
                    if (ndImageUrl) {
                        ndImage.attr('src', ndImageUrl);
                        ndImage.removeAttr('data-src');
                    }
                }
            });
            $oUl.animate({
                left: -$aLiWidth * index2,
            }, 500);
        }
        oRight.on('click', () => {
            if (index >= $aLi.length - 1) {
                $oUl.css('left', 0);
                index = 0;
            }
            index++;
            switchLi(index);
        });
        oLeft.on('click', () => {
            if (index <= 0) {
                $oUl.css('left', -$aLiWidth * ($aLi.length - 1));
                index = $aLi.length - 1;
            }
            index--;
            switchLi(index);
        });
    }
    // 估值站直接跳转到本页面，重写与线索提交来源有关的字段
    function changeFieldFromAppraisement() {
        const params = Util.parseQueryString(location.href);
        const { mobile, submit_sources, fr } = params;
        if (mobile) {
            $('#sales_mobile_number').val(mobile);
        }
        if (fr) {
            $('#sell_phone_source').val(fr);
        }
        if (submit_sources) {
            $('#sales_submit').attr('rrc-tel-button', submit_sources);
        }
    }
    // 团车的情况下初始化页面
    function initTuanche() {
        const isTuanCheCity = RRC.tuancheCity && RRC.tuancheCity.length && RRC.tuancheCity.indexOf(RRC.city) > -1;
        if (isTuanCheCity) {
            $('.label-phone').hide();
            $('#js-sales-footer').addClass('tuanche-sales-footer').find('.input-your-tele').after('<div class="sell-footer-plan"><input type="hidden" id="buy_car_plan_val"><span class="sell-info-buy-car">卖车后是否还买车</span><span class="plan-sell-triangle"></span><div class="buy-car-plan sell-info-buy-car-hide" id="sell_info_plan"><p class="plan-list" data-plan="new">买新车</p><p class="plan-list" data-plan="old">买二手车</p><p class="plan-list" data-plan="no">不买车</p></div></div>'); // eslint-disable-line
            // 团车城市下才会有卖车后计划 按钮
            $('.sell-footer-plan').click((e) => {
                e.stopPropagation();
                $('.sell-footer-plan .buy-car-plan').toggleClass('sell-info-buy-car-hide');
                $('.sell-footer-plan .plan-sell-triangle').toggleClass('plan-triangle-open');
                log.push(['_trackEvent', `${RRC.pageName}_底部浮层_后续计划`, 'click', '']);
            });
            $('#sell_info_plan').on('click', '.plan-list', function (e) {
                e.stopPropagation();
                $('.sell-footer-plan .sell-info-buy-car').html($(this).html()).css('color', 'black');
                // $('#js-choice-box').val($(this).data('plan'));
                $('.sell-footer-plan .buy-car-plan').toggleClass('sell-info-buy-car-hide');
                $('.sell-footer-plan .plan-sell-triangle').removeClass('plan-triangle-open');
                log.push(['_trackEvent', `${RRC.pageName}_底部浮层_${$(this).html()}`, 'click', '']);
            });
        }
    }
    // 底部浮层,首屏不出现，用户滑动下拉时出现
    function showBottomInput() {
        require(['jquery.throttle'], () => {
            const $salesFooter = $('#js-sales-footer');
            $(window).scroll($.throttle(200, () => {
                if ($salesFooter.is(':hidden') && $(window).scrollTop() > 500) {
                    $salesFooter.show();
                }
            }));
        });
    }
    // 采用优雅降级 支持css3的使用css3 不支持的使用show hide
    function initHistorySales() {
        const city_content = $('.city-content-1');
        const landMarkLogo = $('.city .landmark-2');
        const landMarkBig = $('.city .landmark-bg');
        const isSupport = Util.isStyleAttributeSupported('transform', true);
        // 缓冲下载图片
        function updateSellerImage(ndContainer) {
            const sellerImage = $(ndContainer).find('.seller-pic img');
            const sellerImageUrl = sellerImage.attr('data-src');
            if (sellerImageUrl) {
                sellerImage.attr('src', sellerImageUrl);
                sellerImage.removeAttr('data-src');
            }
        }
        // 对不支持的鼠标移动的时候做处理
        function city_content_off_unSupport() {
            city_content.hide();
            landMarkLogo.show();
        }
        // 给地图的元素添加css3属性
        function addCss3(dom, attribute) {
            dom.css('transform', attribute);
            dom.css('webkitTransform', attribute);
            dom.css('mozTransition', attribute);
            dom.css('msTransition', attribute);
        }
        // 对支持CSS3的对鼠标移出的时候处理
        function city_content_off_support() {
            addCss3(city_content, 'translate(136px,146px) scale(0)');
            addCss3(landMarkLogo, 'scale(1)');
            addCss3(landMarkBig, 'scale(1)');
        }
        // 支持CSS3的鼠标移动上去的放大效果
        function city_content_carousel_support(oIndex) {
            addCss3(city_content.eq(oIndex), 'translate(0px,0px) scale(1)');
            addCss3(landMarkLogo.eq(oIndex), 'scale(0)');
            addCss3(landMarkBig.eq(oIndex), 'scale(3)');
        }
        // 不支持的鼠标移动上去 效果
        function city_content_carousel_unSupport(oIndex) {
            city_content.eq(oIndex).show();
            landMarkLogo.eq(oIndex).hide();
        }
        // 关闭所有放大的故事
        function city_content_off() {
            if (isSupport) {
                city_content_off_support();
            } else {
                city_content_off_unSupport();
            }
        }
        // 展示这个城市的详细故事 放大
        function city_content_carousel(index) {
            const oIndex = $(this).attr('data-num') || index;
            updateSellerImage(city_content.eq(oIndex));
            city_content_off();
            if (isSupport) {
                city_content_carousel_support(oIndex);
            } else {
                city_content_carousel_unSupport(oIndex);
            }
        }
        function initSupport() {
            // 对不支持transform 的单独处理 采取优雅降级
            if (navigator.userAgent.indexOf('iPad') > -1) {
                $('.sales-circle-map').on('click', '.city', function () {
                    city_content_carousel.call(this);
                });
            } else {
                $('.sales-circle-map').on('mouseenter', '.city', function () {
                    city_content_carousel.call(this);
                }).on('mouseleave', () => {
                    city_content_off();
                });
            }
        }
        function initNoSupport() {
            addCss3(city_content, 'none');
            $('.sales-circle-map').on('mouseover', '.city', function () {
                city_content_carousel.call(this);
            }).on('mouseout', '.city', () => {
                city_content_off();
            });
        }
        function initMap() {
            city_content.show();
            // 地图初始化
            city_content_carousel(22);
            if (isSupport) {
                initSupport();
            } else {
                initNoSupport();
            }
        }
        initMap();
    }
    // 缓冲加载图片
    function initImageLazyLoading() {
        // 适合详情页效果展示，后续优化成动画效果
        require(['jquery.lazyload'], () => {
            $('.history-sales-cars .img-lazy').lazyload({ threshold: 100, data_attribute: 'src' });
        });
    }
    function initTelephone() {
        if (!$.cookie('rrc_login_token')) {
            return false;
        }
        const $telephone = $.cookie('rrc_login_phone');
        $('#sell_mobile_number').val($telephone);
        $('#telInput').val($telephone);
    }
    function initSaleNum() {
        function pad(num, n) {
            let len = num.toString().length;
            while (len < n) {
                num = `0${num}`;
                len++;
            }
            num += '';
            return num;
        }
        const saleNum = Number($('.sale-num').data('num'));
        const numStr = pad(saleNum, 6);
        const saleNumArr = numStr.split('');
        for (let i = 0; i < 6; i++) {
            $('.sale-num').children('div').eq(i).append(`<span>${saleNumArr[i]}</span>`);
        }
    }

    function initSeeMoreServerInfo() {
        $('.server-for-more').on('click', function () {
            $('.mengceng').show();
        });
        $('.server-close-btn').on('click', function () {
            $('.mengceng').hide();
        });
        $('.mengceng').on('click', function (e) {
            if (e.currentTarget === e.target) {
                $(this).hide();
            }
        });
    }

    // 卖车调研弹窗
    function initSurveyDialog() {
        const offlineDate = new Date(2017, 6, 9, 24);
        const now = new Date();
        if (now - offlineDate >= 0) {
            // 下线
            return;
        }

        const fr = RRC.fr;
        // 当且仅当如下 fr 时弹出
        const popupFrs = ['1052', '1293', 'bd_jzbk', 'bd_jzsp', 'bd_jztp', 'bd_jzxw', 'bd_jzzd', 'bd_other', 'bd_pz', 'bd_sem', 'hs_sem', 'sg_pz', 'sg_sem', 'sm_pz', 'sm_sem'];

        // 今天是否已经弹出
        const isShowToday = !!$.cookie('rrc_detail_survey_dialog');
        // 总弹出次数
        const totalShowNum = parseInt($.cookie('rrc_detail_survey_dialog_total'), 10) || 0;

        if (popupFrs.indexOf(fr) !== -1 &&
            // 当天没有弹过
            !isShowToday &&
            // 总弹出次数不足两次
            totalShowNum < 2
        ) {
            setTimeout(function () {
                const $dialog = $('#survey-dialog');
                // 显示弹窗
                $dialog.fullscreen({
                    backdrop: 'static',
                    show: true,
                }).on('click', () => {
                    $dialog.fullscreen('hide');
                });

                $dialog.find('.close-btn').on('click', () => {
                    $dialog.fullscreen('hide');
                });
                // 种 cookie
                $.cookie('rrc_detail_survey_dialog', 1, { expires: 1 });
                $.cookie('rrc_detail_survey_dialog_total', totalShowNum + 1, { expires: 7 });
            }, 10000);
        }
    }

    function initIntentLaw() {
        Util.intentLawHandle($('#js-sales-provision-select'), $('#sales_submit'));
    }

    function init() {
        initIntentLaw();
        // 如果是团车的城市
        initTuanche();
        // 卖车输入框交互
        initSellerStory();
        changeFieldFromAppraisement();
        showBottomInput();
        initHistorySales();
        initImageLazyLoading();
        initTelephone();
        initSaleNum();
        initSeeMoreServerInfo();
        saleCar.init($('#sales_submit,#telButton1'));
        if (Util.isLegacyBrowser()) {
            $('#telInput').css('height', '65%');
        }
        initSurveyDialog();
    }
    return {
        init,
        initSellerStory,
        changeFieldFromAppraisement,
        initTuanche,
        showBottomInput,
        initHistorySales,
        initImageLazyLoading,
        initTelephone,
        initSaleNum,
        initSeeMoreServerInfo,
    };
});
/* istanbul ignore if */
if (typeof window.__karma__ === 'undefined') {
    require(['page/sales'], (page) => {
        page.init();
    });
}
